import { SortQueryDefaulted } from '@adflow/shared/util-data';

import type { ViewHistoryGoogleAdsTemplateDto } from './history-google-ads-template.dto';

const HistoryGoogleAdsTemplateSortableFields: (keyof ViewHistoryGoogleAdsTemplateDto)[] =
	['user', 'createdAt', 'action'] as const;

export const DEFAULT_HISTORY_GOOGLE_ADS_TEMPLATE_SORT = 'createdAt';
export const DEFAULT_HISTORY_GOOGLE_ADS_TEMPLATE_SORT_DIR = 'desc';

export const ListHistoryGoogleAdsTemplateSort = SortQueryDefaulted(
	HistoryGoogleAdsTemplateSortableFields,
	DEFAULT_HISTORY_GOOGLE_ADS_TEMPLATE_SORT,
	DEFAULT_HISTORY_GOOGLE_ADS_TEMPLATE_SORT_DIR
);
